import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { roadsideQueryKeys } from "./queryKeys"
import { useRoadsideQuery } from "./useRoadsideQuery"

export function useRoadsideProject() {
    const { selectedNetwork } = useNetworksStateContext()
    const url = `projects/${selectedNetwork.slug}/`

    const queryKey = roadsideQueryKeys["project"]()

    return useRoadsideQuery(
        url,
        queryKey,
    )
}